import { Box } from '@mui/material';
import ExoForm from '../../components/exo/ExoForm';
import * as Yup from 'yup';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import Feedback from '../../components/special/Feedback';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const NewSick = ({
  onCreate,
  onCancel,
  userId,
  // Editing an existing pending request supersedes it: the backend declines
  // the old request and creates this one in its place.
  existingRequest,
  startDataCollection,
}) => {
  const { t } = useTranslation();
  const existingRequestId = existingRequest?.id;

  const fields = [
    {
      label: t('Start'),
      type: 'date',
      key: 'startDate',
    },
    {
      label: t('End'),
      type: 'date',
      key: 'endDate',
    },
    {
      label: t('Comment'),
      type: 'text',
      key: 'comment',
      multiline: true,
      colspan: 2,
    },
  ];

  const config = useConfig();

  const validationSchema = Yup.object().shape({
    startDate: Yup.string().required(t('Start Date is required')),
    endDate: Yup.string().required(t('End Date is required')),
  });

  function handleSubmit(values) {
    const baseData = {
      type: 'sick',
      comment: values.comment,
      values: JSON.stringify({
        startDate: values.startDate,
        endDate: values.endDate,
      }),
    };

    const data = {
      ...baseData,
      ...(userId ? { userId } : {}),
      ...(existingRequestId ? { id: existingRequestId } : {}),
    };

    DBRequest({
      config,
      path: 'employeerequests/sick',
      method: API_POST(data),
      onResponse: handleCreation,
      onFeedback: handleAlertOpen,
    });
  }

  function handleCreation(data) {
    onCreate(data.data);
    onCancel();
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <Box className="p-4">
      <ExoForm
        noDifferences
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        header={existingRequestId ? t('Edit Sick Report') : t('New Sick Report')}
        validationSchema={validationSchema}
        className="grid grid-cols-2 gap-4"
        startDataCollection={startDataCollection}
      />
      <Feedback setState={setAlertState} state={alertState} />
    </Box>
  );
};

export default NewSick;
